import React, { useState, useEffect } from "react";
import images from "../images";
import photocard_images from "./object-lists/photocard-images";
import { collection, doc, setDoc, onSnapshot  } from "firebase/firestore"; 
import { database } from "../firebaseConfig2";

function Status() {
//   console.log("In STATUS MAIN");

const [status, setStatus] = useState({
    date: 'Loading...', 
    message: 'Loading...'});
const [statusList, setStatusList] = useState([]);
    
   useEffect(
       () =>
         onSnapshot(collection(database, "statuses"), (snapshot) => {
           snapshot.forEach((doc) => {
               let tempdate = new Date(doc.data().date).toLocaleDateString("en-US");
   
   
             if (tempdate == "Invalid Date"){
               tempdate = doc.data().date;
             }
             let tempstatus = {
               date: tempdate,
               message: doc.data().message,
               type: doc.data().type
             }
             setStatusList(statusList.push(tempstatus));
           });
           setStatus(statusList.at(-1));
         }),
       []
     );


    return (
        <div className="status-wrapper">
            <div className="status-title">
              <p>⊹ status</p>
              <p>{status.date}</p>
              </div>
              <div className = "status">
                <div id="actual-status-container" className='status-details'>

                <div className = "status-message" id="actual-homepage-status">
                  {status.type == "string" &&
                    <p>{status.message}</p>
                  }
                  {status.type == "image" &&
                    <img className="status-img"src={status.message}></img>
                  }
                </div>
                </div>
              </div>
            </div>
    );
  }

  export default Status;